import { Skeleton } from "@mui/material";
import { Wrapper } from "./styles";

export default function TemplatesTableSkeleton() {
  return (
    <Wrapper>
      <Skeleton width={240} height={160} variant="rectangular" />
      <Skeleton width={240} height={160} variant="rectangular" />
      <Skeleton width={240} height={160} variant="rectangular" />
      <Skeleton width={240} height={160} variant="rectangular" />
      <Skeleton width={240} height={160} variant="rectangular" />

      <Skeleton width={240} height={160} variant="rectangular" />
      <Skeleton width={240} height={160} variant="rectangular" />
      <Skeleton width={240} height={160} variant="rectangular" />
      <Skeleton width={240} height={160} variant="rectangular" />
      <Skeleton width={240} height={160} variant="rectangular" />
    </Wrapper>
  );
}
